import React, { useState } from "react";
import styled from "styled-components";
import IconWinner from "../../../../../assets/images/Event-2026/winner.svg";
import IconWinnerTBN from "../../../../../assets/images/Event-2026/winnerTBN.svg";
import Winner from '../Winner/Winner';
import { useTranslation } from 'react-i18next';

function TitleLogo({ width, height, isPopup = false, logo, ...props }) {
  const { i18n } = useTranslation()
  const [isShowPopup, setIsShowPopup] = useState(false);

  return (
    <>
      <Container $isPopup={isPopup} {...props}>
        <img src={i18n.language === 'en' ? IconWinner : IconWinnerTBN} alt="icon" className='winner'
          onClick={() => setIsShowPopup(true)}
        />
        <img
          src={logo}
          className='title-logo'
          alt='title logo'
          width={width}
          height={height}
        />
      </Container>
      <Winner isOpen={isShowPopup} setIsOpen={setIsShowPopup} />
    </>
  );
}

export default TitleLogo;

const Container = styled.div`
  position: relative;
  .winner{
    position: absolute;
    top: 28%;
    left: 5%;
    object-fit: contain;
    height: 100px;
    width: 100px;
    z-index: 10 !important ;
    pointer-events: auto;

    cursor: pointer;

    @media (max-width: 768px) {
      height: 50px;
      width: 50px;
      top: 17%;
      left: 5%;
      z-index: 10 !important;

    }
    @media (max-width: 1024px) {
			top: 20%;
      height: 70px;
      width: 70px;
      z-index: 10 !important;
		}
  }

  .icon-winner__collect {
    position: absolute;
    bottom: -85px;
    left: 0;
    cursor: pointer;
    z-index: 3;
  }

  .icon-te__collection {
    position: absolute;
    left: -90px;
    z-index: 1;
    bottom: -190px;
    pointer-events: none;
  }

  .title-logo {
    display: block;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    /* padding: 0 30px; */
    margin-top: 10px;
    margin-bottom: 5px;
    width: 100%;
    max-width: 580px;
  }

  &.thadingyut-theme-logo {
    .title-logo {
      max-width: 100%;
      width: 80%;

      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .icon-sung__collection {
    position: absolute;
    right: -70px;
    z-index: 1;
    bottom: -173px;
    pointer-events: none;
  }

  @media (max-width: 768px) {
    .title-logo {
      width: 340px;
    }
  }

  @media (max-width: 576px) {
    .title-logo {
      /* margin-top: 35px; */
      // margin-top: 35px;
    }

    .title-logo {
      // width: 350px;
      max-width: 100%;
    }

    .icon-winner__collect {
      width: 74px;
    }

    .icon-te__collection {
      width: 192px;
      left: -60px;
      bottom: -85px;
    }

    .icon-sung__collection {
      right: -50px;
      width: 210px;
      bottom: -80px;
    }

    /* margin-bottom: ${(props) => (props.isPopup ? "0" : "70px")}; */
  }
`;
